const KEY_FETCH_ERROR = 'KeyFetchError';

// Unlike NoKeyError, the user may well have a key — it just could not be read,
// so nothing may treat the key as absent.
class KeyFetchError extends Error {
  constructor() {
    super('failed to fetch the user private key');
    this.name = KEY_FETCH_ERROR;
  }
}

export default KeyFetchError;
